function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M19.667,2.221a17.5,17.5,0,0,1,5.44,6.134l.138.251-.138.249a17.524,17.524,0,0,1-5.44,6.134,12.527,12.527,0,0,1-7.045,2.223A12.529,12.529,0,0,1,5.58,14.991,17.514,17.514,0,0,1,.138,8.854L0,8.606l.138-.251a17.5,17.5,0,0,1,5.44-6.134A12.541,12.541,0,0,1,12.622,0a12.546,12.546,0,0,1,7.045,2.221ZM12.489,4.555l.838.08a2.838,2.838,0,0,0-.475,1.576,2.737,2.737,0,0,0,2.691,2.782,2.6,2.6,0,0,0,1.313-.353c.006.1.01.193.01.292a4.378,4.378,0,1,1-4.378-4.376Zm9.9,4.051a14.049,14.049,0,0,0-4.271-4.748,9.79,9.79,0,0,0-5.5-1.742,9.788,9.788,0,0,0-5.5,1.742A14.075,14.075,0,0,0,2.851,8.606a14.027,14.027,0,0,0,4.273,4.746,9.788,9.788,0,0,0,5.5,1.742,9.8,9.8,0,0,0,5.5-1.742,14.022,14.022,0,0,0,4.271-4.746Z"
});

function SvgEyeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25.244 17.212",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eyeIcon.c810728c.svg";
export { ForwardRef as ReactComponent };